import { CircularProgress } from "@mui/material";

export function InProgressIcon() {
  return <CircularProgress sx={(theme) => ({ color: theme.palette.secondary.light })} thickness={3} size={18} />;
}
